import React, { useState } from "react";
import {
  faExclamationTriangle,
  faCheckCircle,
} from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Modal, Button } from "react-bootstrap";
import ConfirmationPopUpCard from "./ConfirmationPopupCard";

const ManualOverridePopupCard = ({
  func,
  confirmFund,
  setConfirmFund,
  onSubmit,
  confirmManualOverrideFund,
  setConfirmManualOverrideFund,
  flag,
  setFlag,
  msg,
  achTotal,
  bankNameDetails,
}) => {
  return (
    <div
      style={{
        padding: "16px",
        width: "100%",
        background: "#F6F6F6",
        borderRadius: "8px",
      }}
    >
      <div>
        <FontAwesomeIcon
          size={"2x"}
          color="#A05A06"
          icon={faExclamationTriangle}
        />
        <span className="m-2 fw-100 ft-20" style={{ color: "#A05A06" }}>
          Manual Override?
        </span>
        <Button
          onClick={() => setConfirmFund(false)}
          style={{ position: "absolute", right: "140px" }}
          variant="secondary"
        >
          Cancel
        </Button>
        <Button
          onClick={() => func()}
          // onClick={async () => {
          //     setFlag(true);
          //     await setTimeout(() => {
          //         setFlag(false);
          //         //setConfirmFund(false);
          //     }, 3000);

          // }}
          // onClick={()=>onSubmit()}
          style={{ position: "absolute", right: "40px" }}
          variant="primary"
        >
          Confirm
        </Button>
      </div>
      <p style={{ marginTop: "1rem" }}>
        Are you sure you want to confirm the {msg}
      </p>
      <p>
        {bankNameDetails} - $ {achTotal} as received
      </p>
    </div>
  );
};

export default ManualOverridePopupCard;
